// Tính năng trang Báo cáo tổng quan
const SHIPPING_ADD = 'report_stock_card_add';
const SHIPPING_LIST = 'shipping'

export const PERMISSION_SHIPPING = {
  SHIPPING_LIST,
  SHIPPING_ADD,
};
